<template>
  <div class="headerWrap">
    <header>
      <!-- <div class="top">
                <div class="w12 clearfix">
                    <div class="fl"><i class="icons icon-site"></i>全站导航</div>
                    <div class="headerTop fr">

                        <div class="topLi fr"><i class="icons icon-live"></i></div>
                        <div class="topLi fr">
                            <i class="icons icon-app"></i>
                            <p class=""><img src=""></p>
                        </div>
                        <div class="topLi fr">
                            <i class="icons icon-h5"></i>
                            <p class=""><img src=""></p>
                        </div>
                    </div>
                </div>
            </div> -->
      <div class="header">
        <div class="clearfix">
          <div class="logo fl" v-if="routepath&&!apiSecret">
            <img
              class="logo-img"
              src="static/images/logo.png"
              :onerror="defaultImg"
            />
          </div>
          <div class="topLi fr" v-if="!apiSecret">
            <div class="drop-down userTop-down" v-if="routepath">
              <div class="drop cp" :v-if="routepath">
                <img
                  class="topImg fl"
                  v-if="headImg != undefined"
                  :src="headImg"
                  :onerror="defaultImg"
                />
                <span class="ml5">{{ realname }}</span>
                <i class="icons-arrow"></i>
              </div>
              <ul class="option r ac">
                <li>
                  <a
                    class="cr47 tdhidden"
                    target="_blank"
                    href="https://u1.nybkz.com/user/index?redirect_url=https://hot.nybkz.com/"
                    >{{ usename }}</a
                  >
                </li>
                <li class="divline"></li>
                <li><a href="/myFavorites">我的收藏</a></li>
                <li>
                  <a href="javascript:void(0);" @click="logOut">退出登录</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="search-warp w337 fr" v-if="$route.meta.keepAlive != 3">
                        <button class="search-btn fr cp" @click="KeyUpEsc">查询指数</button>
                        <div class="hidden">
                            <input type="text" v-model="keywords" @keyup.enter="KeyUpEsc" placeholder="输入人名/地名/公司/机构/事件关键词" class="input-text fl">
                        </div>
                    </div> -->
          <div class="nav-menu fl">
            <ul v-if="!apiSecret">
              <li v-for="(item, index) in menuList" :key="index" >
                <router-link
                  class="db"
                  exact
                  :to="item.link"
                  v-if="item.id === 1"
                  ><i class="icons fl" :class="'nav-icon' + item.id"></i
                  >{{ item.name }}</router-link
                >
                <a
                  class="db"
                  :href="item.link"
                  v-else-if="item.id == 7"
                  target="_blank"
                  ><i class="icons fl" :class="'nav-icon' + item.id"></i
                  >{{ item.name }}</a
                >
                <router-link
                  class="db"
                  :class="{
                    'router-link-active':
                      ($route.meta.pageType === 2 && item.id == 2) ||
                      ($route.meta.pageType === 6 && item.id == 4) ||
                      ($route.meta.pageType === 5 && item.id == 5) ||
                      ($route.meta.pageType === 3 && item.id == 3) ||
                      ($route.meta.pageType === 7 && item.id == 6),
                  }"
                  :to="{ path: item.link, query: { type: item.type } }"
                  v-else
                  >{{ item.name }}
                  <i :class="item.icons" v-if="item.icons">{{ item.icons }}</i>
                </router-link>
              </li>
            </ul>
            <ul v-if="apiSecret">
             <li v-if="$route.path != '/newsN'">
                <router-link
                  class="db"
                  :class="{
                    'router-link-active':
                     $route.meta.pageType === 1
                  }"
                  :to="{ path: 'indexN', query: { api_secret:apiSecret } }"

                  >首页
                </router-link>
              </li>
              <li v-if="$route.path == '/newsN'">
                <router-link
                  class="db"
                  :class="{
                    'router-link-active':
                     $route.meta.pageType === 1
                  }"
                  :to="{ path: 'newsN', query: { api_secret:apiSecret } }"

                  >读数据
                </router-link>
              </li>
               <li v-if="$route.path != '/newsN'">
                <router-link
                  class="db"
                  :class="{
                    'router-link-active':
                      $route.meta.pageType === 2
                  }"
                   :to="{ path: 'eventsN', query: { api_secret:apiSecret } }"

                  >看事件
                </router-link>
              </li>
               <li v-if="$route.path != '/newsN'">
                <router-link
                  class="db"
                  :class="{
                    'router-link-active':
                      $route.meta.pageType === 6
                  }"
                   :to="{ path: 'eveningPaperN', query: { api_secret:apiSecret } }"

                  >晨晚报
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  props: "",
  data() {
    return {
      apiSecret : this.$route.query.api_secret,
      usename: "", //用户名
      realname: "",
      headImg: "",
      defaultImg: 'this.src="static/images/img.png"',
      menuList: [
        { id: 1, name: "首页", link: "/" },
        { id: 2, name: "读数据", link: "/news" },
        { id: 3, name: "看事件", link: "/events" },
        { id: 4, name: "晨晚报", link: "/eveningPaper" },
        { id: 7, name: "知识图谱", link: "http://kg.nybkz.com/" },
        // {id:4,name:'说观点',link:'/viewpoint',type:'人间'},
        { id: 5, name: "传播指数", link: "/transIndex" },
        { id: 6, name: "情绪地图", link: "/emotionArea", icons: "beta" },
      ],
      keywords: "",
      routepath: true,
    };
  },
  mounted() {
    let that = this;
     if (that.$route.path == "/Events_test"||that.$route.path == "/events_test") {
        (that.routepath = false),
          (that.menuList = [{ id: 1, name: "看事件", link: "/events_test" }]);
      }
    that.$nextTick(() => {
      that.dataAjax();

    });
  },
  methods: {
    getCookie(c_name) {
      if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          let c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) c_end = document.cookie.length;
          return unescape(document.cookie.substring(c_start, c_end));
        }
      }
      return "";
    },
    dataAjax() {
      let that = this;
      that.$api.get("user/index/info",  {api_secret:that.apiSecret}, (r) => {
        that.$parent.returnCode(r, function () {
          that.headImg = r.data.head_img;
          that.usename = r.data.username;
          that.realname = r.data.realname;
          if(r.data.webStyle && r.data.webStyle === 'black'){
            document.documentElement.style.setProperty('--gray-scale','grayscale(100%)')
          }
        });
      });
    },
    logOut() {
      let that = this;
      that.$parent.loadModal(true, "正在退出登录...");
      that.$api.get("user/index/logout", null, (r) => {
        that.$parent.returnCode(r, function () {
          let url = "http://hot.nybkz.com/";
          window.location.href = url;
        });
      });
    },
    KeyUpEsc() {
      let that = this;
      if (that.keywords == "") {
        that.$utils.alertText("输入人名/地名/公司/机构/事件关键词", 300);
        return;
      }
      that.$router.push({
        path: "/transDetail",
        query: { keyword: that.keywords },
      });
    },
  },
};
</script>
<style lang="" scope>
.headerWrap {
  position: fixed;
  width: 100%;
  height: 68px;
  box-shadow: 0 0 2px #ddd;
  z-index: 2;
}
.header {
  background: var(--header-bg);
  height: 68px;
  z-index: 2;
  padding: 0 30px 0 40px;
  font-family: "Microsoft YaHei";
}
.top {
  background-color: #181818;
  height: 36px;
  color: #99a5ad;
  padding: 5px 0;
  line-height: 26px;
}
.topImg {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.topLi {
  line-height: 36px;
  position: relative;
  z-index: 2;
  padding-top: 16px;
  color: #525e66;
}
.topLi + .topLi:before {
  content: "";
  width: 1px;
  height: 14px;
  background-color: rgba(116, 116, 116, 0.7);
  float: right;
  margin: 7px 15px;
}
.logout {
  display: inline-block;
}
.topLi p {
  display: none;
  width: 134px;
  height: 134px;
  background-color: #fff;
  border: 1px solid #ddd;
  top: 31px;
  position: absolute;
  left: -15px;
  padding: 10px;
}
.topLi:hover p {
  display: block;
}
.header .logo {
  margin: 13px 50px 0 35px;
}
.logo img {
  height: 40px;
}
.nav-menu li {
  float: left;
  position: relative;
  line-height: 65px;
}
.nav-menu li a {
  padding: 0 25px;
  color: var(--header-color);
  font-size: 16px;
  cursor: pointer;
}
.nav-menu li a:hover {
  text-decoration: none;
  color: #2799df;
}
.nav-menu li .router-link-active:not(.active-none) {
  border-bottom: 3px solid #2799df;
  color: #2799df;
}
.nav-menu li .beta {
  width: 34px;
  color: #fff;
  background-color: #e52e45;
  border-radius: 2px;
  font-size: 12px;
  padding: 0 3px;
  position: absolute;
  line-height: 16px;
  top: 14px;
  right: -12px;
}
.search-btn {
  background-color: #2799df;
  color: #fff;
  width: 68px;
  height: 40px;
  line-height: 40px;
  border: none;
  border-radius: 0 3px 3px 0;
}
.search-warp {
  margin: 19px 0 0 25px;
}
.search-warp .input-text {
  height: 40px;
  border-radius: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/topMenu.vue